var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    clipPath: "url(#clip0_2663_60026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 24.0039C19.1274 24.0039 24.5 18.6313 24.5 12.0039C24.5 5.37649 19.1274 0.00390625 12.5 0.00390625C5.87258 0.00390625 0.5 5.37649 0.5 12.0039C0.5 18.6313 5.87258 24.0039 12.5 24.0039Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.1711 15.4708L17.7026 12.0012H14.3748V9.75008C14.3748 8.80169 14.8389 7.87524 16.3307 7.87524H17.8444V4.92207C17.8444 4.92207 16.4707 4.6875 15.1579 4.6875C12.4173 4.6875 10.6252 6.34803 10.6252 9.35689V12.0012H7.57748V15.4708H10.6252V23.8561C11.236 23.9523 11.8621 24.0012 12.5 24.0012C13.1379 24.0012 13.764 23.9506 14.3748 23.8561V15.4708H17.1711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2663_60026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.faeb8d23845b278f2478511db7bd0ef9.svg";
export { ForwardRef as ReactComponent };